/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { DocumentNode, gql } from "@apollo/client";
import Query from "../../../Basis/Queries/Query";
import Firmendaten from "./Firmendaten";

export default class LadeEigeneFirmendaten extends Query<Firmendaten, void> {
    public static readonly queryName: string = "Mandanten_LadeEigeneFirmendaten";

    private static readonly query: DocumentNode = gql`
        query ${LadeEigeneFirmendaten.queryName} {
            ${LadeEigeneFirmendaten.queryName} {
                firmendatenId
                mandantId
                mandantGeaendert
                matchcode
                name1
                name2
                name3
                strasse
                postleitzahl
                ort
                region
                land
                landBezeichnung
                eMail
                mobil
                telefon
                fax
                umsatzsteuerIdNr
                steuernummer
                hatRechnungsadresse
                rechnungsadresseName1
                rechnungsadresseName2
                rechnungsadresseName3
                rechnungsadresseStrasse
                rechnungsadressePostleitzahl
                rechnungsadresseOrt
                rechnungsadresseRegion
                rechnungsadresseLand
                rechnungsadresseEMail
                rechnungsadresseMobil
                rechnungsadresseTelefon
                rechnungsadresseFax
                rechnungsadresseUmsatzsteuerIdNr
                rechnungsadresseSteuernummer
                anzahlMitarbeitendeId
                schwerpunktId
                schwerpunktSonstiges
                zusatzangabe1
                zusatzangabe2
                zusatzangabe3
                bank
                iban
                bic
                steuerart
                waehrung
                homepage
                zeitzone
                kultur
                standardSteuersatz
                rechnungenAnEUAuslandMitUmsatzsteuerIdSindSteuerfrei
                rechnungenAnNichtEUAuslandSindSteuerfrei
                einenBelegProTeilnahmeErzeugen
                belegeNichtAutomatischVersenden
            }
        }
    `;

    constructor(onCompleted: (data: Firmendaten) => void) {
        super(LadeEigeneFirmendaten.query, onCompleted);
    }

    public get name(): string {
        return LadeEigeneFirmendaten.queryName;
    }
}
